module.exports = __webpack_public_path__ + "static/jkuahl4545sdf-01b5121b79901d990f87938b73f522ac.jpg";